import './sectionMetrics.scss';

import { TimelineLite, TweenMax } from 'gsap';
import ScrollMagic from 'scrollmagic';

export default (() => {
	$(document).ready(function () {
		if ($('.section--metrics').length > 0) {
			const controller = new ScrollMagic.Controller();
			// news animation
			const section = document.querySelector('.section--metrics');
			new ScrollMagic.Scene({
				triggerElement: section,
				triggerHook: '0.5'
			})
				.on('enter', e => {
					if ($('.front-page').length > 0) {
						section.querySelector('.title').classList.add('title--completed');
					}
				})
				.on('leave', e => {
					if ($('.front-page').length > 0) {
						section.querySelector('.title').classList.remove('title--completed');
					}
				})
				.addTo(controller);
			$($('.metrics__item')[0]).hover(
				function () {
					new TimelineLite()
						.to('.download-anim1', 0.15, {
							y: 11
						})
						.to('.download-anim1', 0.1, {
							y: 7
						});
				},
				function () {
					new TimelineLite().to('.download-anim1', 0.1, {
						y: 0
					});
				}
			);
			$($('.metrics__item')[1]).hover(
				function () {
					new TimelineLite()
						.fromTo(
							'.daily-anim2, .daily-anim1',
							0.2,
							{
								scaleY: 0.1,
								transformOrigin: '50% 50%'
							},
							{
								scaleY: 1.8
							}
						)
						.to('.daily-anim2, .daily-anim1', 0.2, {
							scaleY: 1
						})
						.to(
							'.daily-anim2',
							0.2,
							{
								scaleY: 0
							},
							'+=0.25'
						)
						.to('.daily-anim2', 0.2, {
							scaleY: 0.7
						})
						.fromTo(
							'.daily-anim3',
							0.2,
							{
								y: 30,
								opacity: 0
							},
							{
								y: 0,
								opacity: 1
							},
							'-=0.25'
						);
				},
				function () {
					new TimelineLite().to('.daily-anim2', 0.2, {
						scaleY: 1
					});
				}
			);
			$($('.metrics__item')[1]).hover(
				function () {
					new TimelineLite()
						.to('.star-anim1', 0.2, {
							scale: 1.1,
							transformOrigin: '50% 50%'
						})
						.to(
							'.star-anim2',
							0.2,
							{
								scale: 1.4,
								opacity: 1,
								transformOrigin: '50% 50%'
							},
							'-=0.2'
						);
				},
				function () {
					new TimelineLite().to('.star-anim1', 0.2, {
						scale: 1
					});
					new TimelineLite().to('.star-anim2', 0.1, {
						scale: 1,
						opacity: 0
					});
				}
			);
			$($('.metrics__item')[2]).hover(
				function () {
					new TimelineLite()
						.fromTo(
							'.monthly-anim1',
							0.5,
							{
								y: -80,
								opacity: 0
							},
							{
								y: -40,
								opacity: 1,
								onComplete: () => {
									TweenMax.fromTo(
										'.monthly-anim1',
										0.5,
										{
											rotation: 360,
											transformOrigin: '50% 50%',
											overwrite: 'none'
										},
										{
											rotation: -360,
											transformOrigin: '50% 50%',
											overwrite: 'none'
										}
									);
								}
							}
						)
						.to(
							'.monthly-anim1',
							0.5,
							{
								y: 0
							},
							'+=0.5'
						);
				},
				function () {
					new TimelineLite().to('.monthly-anim1', 0.1, {
						y: -60,
						opacity: 0
					});
				}
			);
		}
	});
})();
